<template>
  <p
    v-if="
      popularityStatsSales &&
      popularityStatsSales.salesLast7Days &&
      popularityStatsSales.salesLast7Days >= 10
    "
    class="text-static-default-hi caption mt-2"
    data-test="popularity-stats-sales-caption"
  >
    <FormattedMessage
      class="text-static-default-hi caption"
      :definition="translations.popularityStatsSales"
    >
      <template #salesLast7Days>
        <span class="text-static-default-hi caption-bold">
          {{
            i18n(translations.salesLast7Days, {
              numberItemsSold: popularityStatsSales.salesLast7Days,
            })
          }}
        </span>
      </template>
    </FormattedMessage>
  </p>
</template>

<script setup lang="ts">
import type { PopularityStatsSales } from '@backmarket/http-api/src/api-specs-checkout/popularity-stats/popularity-stats.types'
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './PopularityStatsSalesCaption.translations'

defineProps<{
  popularityStatsSales: PopularityStatsSales
}>()

const i18n = useI18n()
</script>
